import React from "react"
import "./style.scss"
import Slider from "react-slick"
import AniLink from "gatsby-plugin-transition-link/AniLink"
import { API_QUOTE_FORM_SUBMIT } from "../../api"

export default class GetQuoteForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      slideIndex: 0,
      form_name: "",
      form_email: "",
      form_company: "",
      form_projectTitle: "",
      form_projectDesc: "",
      form_completionTime: "",
      loadingFlag: false,
    }
    this.handleNext = this.handleNext.bind(this)
    this.handleBack = this.handleBack.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  handleNext(val = -1) {
    if (val === "" && val !== -1) {
      alert("Please enter correct data!")
    } else {
      this.setState({ slideIndex: this.state.slideIndex + 1 })
      this.slider.slickGoTo(this.state.slideIndex + 1)
    }
  }
  handleBack() {
    this.setState({ slideIndex: this.state.slideIndex - 1 })
    this.slider.slickGoTo(this.state.slideIndex - 1)
  }
  async handleSubmit(val = -1) {
    this.setState({ ...this.state, loadingFlag: true })
    //validations
    let result = await API_QUOTE_FORM_SUBMIT(
      this.state.form_name,
      this.state.form_email,
      this.state.form_company,
      this.state.form_projectTitle,
      this.state.form_projectDesc,
      this.state.form_completionTime
    )
    if (result && result.data && result.data.success === 1) {
      this.props.setToastObj({
        heading: "Success",
        desc: "Submitted! We'll get back to you soon 😊",
        timePassed: "Just Now",
      })
      this.handleNext(val);
    } else {
      this.props.setToastObj({
        heading: "Failure",
        desc: "Sorry! An error occurred 😐",
        timePassed: "Just Now",
      })
    }
    this.setState({ ...this.state, loadingFlag: false })
  }

  render() {
    const settings = {
      dots: false,
      infinite: false,
      arrows: false,
      draggable: false,
      touchMove: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      beforeChange: (current, next) => this.setState({ slideIndex: next }),
    }

    return (
      <div className="getQuoteForm container" style={{ maxWidth: "786px" }}>
        <Slider {...settings} ref={slider => (this.slider = slider)}>
          <div className="container d-flex flex-column justify-content-center align-items-center my-5">
            <button
              className="fs-5 btn btn-primary"
              onClick={() => this.handleNext()}
            >
              Get Started <i className="ms-2 bi bi-arrow-right"></i>
            </button>
          </div>
          <div className="container d-flex flex-column justify-content-center align-items-center my-5">
            <div className="row w-100">
              <div className="col-12 fs-2 ps-4 pb-2 text-purple">Your Name</div>
              <div className="col-12">
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="homeContact__name"
                    value={this.state.form_name}
                    onChange={e => {
                      this.setState({
                        ...this.state,
                        form_name: e.target.value,
                      })
                    }}
                    required
                  />
                  <label htmlFor="homeContact__name">
                    Enter your name here
                  </label>
                </div>
              </div>
              <div className="col-12 mt-2 d-flex justify-content-start align-items-center">
                <button
                  className="fs-5 btn btn-primary mx-2"
                  onClick={this.handleBack}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
                <button
                  className="fs-5 btn btn-primary mx-2"
                  onClick={() => this.handleNext(this.state.form_name)}
                >
                  Next <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="container d-flex flex-column justify-content-center align-items-center my-5">
            <div className="row w-100">
              <div className="col-12 fs-2 ps-4 pb-2 text-purple">
                Your Email
              </div>
              <div className="col-12">
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="homeContact__name"
                    required
                    value={this.state.form_email}
                    onChange={e => {
                      this.setState({
                        ...this.state,
                        form_email: e.target.value,
                      })
                    }}
                  />
                  <label htmlFor="homeContact__name">
                    Enter your email here
                  </label>
                </div>
              </div>
              <div className="col-12 mt-2 d-flex justify-content-start align-items-center">
                <button
                  className="fs-5 btn btn-primary mx-2"
                  onClick={this.handleBack}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
                <button
                  className="fs-5 btn btn-primary mx-2"
                  onClick={() => this.handleNext(this.state.form_email)}
                >
                  Next <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="container d-flex flex-column justify-content-center align-items-center my-5">
            <div className="row w-100">
              <div className="col-12 fs-2 ps-4 pb-2 text-purple">
                Your Company
              </div>
              <div className="col-12">
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="homeContact__name"
                    required
                    value={this.state.form_company}
                    onChange={e => {
                      this.setState({
                        ...this.state,
                        form_company: e.target.value,
                      })
                    }}
                  />
                  <label htmlFor="homeContact__name">
                    Enter your company name here
                  </label>
                </div>
              </div>
              <div className="col-12 mt-2 d-flex justify-content-start align-items-center">
                <button
                  className="fs-5 btn btn-primary mx-2"
                  onClick={this.handleBack}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
                <button
                  className="fs-5 btn btn-primary mx-2"
                  onClick={() => this.handleNext(this.state.form_company)}
                >
                  Next <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="container d-flex flex-column justify-content-center align-items-center my-5">
            <div className="row w-100">
              <div className="col-12 fs-2 ps-4 pb-2 text-purple">
                Project Title
              </div>
              <div className="col-12">
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="homeContact__name"
                    required
                    value={this.state.form_projectTitle}
                    onChange={e => {
                      this.setState({
                        ...this.state,
                        form_projectTitle: e.target.value,
                      })
                    }}
                  />
                  <label htmlFor="homeContact__name">
                    Enter a descriptive title for your project
                  </label>
                </div>
              </div>
              <div className="col-12 mt-2 d-flex justify-content-start align-items-center">
                <button
                  className="fs-5 btn btn-primary mx-2"
                  onClick={this.handleBack}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
                <button
                  className="fs-5 btn btn-primary mx-2"
                  onClick={() => this.handleNext(this.state.form_projectTitle)}
                >
                  Next <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="container d-flex flex-column justify-content-center align-items-center my-5">
            <div className="row w-100">
              <div className="col-12 fs-2 ps-4 pb-2 text-purple">
                Project Description
              </div>
              <div className="col-12">
                <div className="form-floating mb-3">
                  <textarea
                    type="text"
                    className="form-control"
                    id="homeContact__name"
                    style={{ height: "150px" }}
                    required
                    value={this.state.form_projectDesc}
                    onChange={e => {
                      this.setState({
                        ...this.state,
                        form_projectDesc: e.target.value,
                      })
                    }}
                  ></textarea>
                  <label htmlFor="homeContact__name">
                    Enter detailed description for your project
                  </label>
                </div>
              </div>
              <div className="col-12 mt-2 d-flex justify-content-start align-items-center">
                <button
                  className="fs-5 btn btn-primary mx-2"
                  onClick={this.handleBack}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
                <button
                  className="fs-5 btn btn-primary mx-2"
                  onClick={() => this.handleNext(this.state.form_projectDesc)}
                >
                  Next <i className="bi bi-arrow-right"></i>
                </button>
              </div>
            </div>
          </div>

          <div className="container d-flex flex-column justify-content-center align-items-center my-5">
            <div className="row w-100">
              <div className="col-12 fs-2 ps-4 pb-2 text-purple">
                Required Completion Time
              </div>
              <div className="col-12">
                <div className="form-floating mb-3">
                  <input
                    type="text"
                    className="form-control"
                    id="homeContact__name"
                    required
                    value={this.state.form_completionTime}
                    onChange={e => {
                      this.setState({
                        ...this.state,
                        form_completionTime: e.target.value,
                      })
                    }}
                  />
                  <label htmlFor="homeContact__name">
                    Enter the time period in which you want the project to be
                    completed
                  </label>
                </div>
              </div>
              <div className="col-12 mt-2 d-flex justify-content-start align-items-center">
                <button
                  className="fs-5 btn btn-primary mx-2"
                  onClick={this.handleBack}
                >
                  <i className="bi bi-arrow-left"></i>
                </button>
                <button
                  className="fs-5 btn btn-primary mx-2"
                  onClick={() => this.handleSubmit(this.state.form_projectDesc)}
                >
                  Submit <i className="ms-2 bi bi-check2"></i>
                </button>
                {this.state.loadingFlag && (
                  <div className="ms-2 spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="container d-flex flex-column justify-content-center align-items-center my-5">
            <div className="row w-100">
              <div className="col-12 fs-1 text-purple text-center">
                Successfully submitted <i className="bi bi-check2-circle"></i>
              </div>
              <div className="col-12 fs-3 text-center">
                We'll get back to you via email soon{" "}
                <span role="img" aria-label="">
                  😊
                </span>
              </div>
              <AniLink
                paintDrip
                hex="#551864"
                to="/"
                className="fs-5 btn btn-primary mx-2 my-3"
              >
                Go to Home
              </AniLink>
            </div>
          </div>
        </Slider>
      </div>
    )
  }
}
